import { render, staticRenderFns } from "./CardNfe.vue?vue&type=template&id=28b8a086&scoped=true&"
import script from "./CardNfe.vue?vue&type=script&lang=js&"
export * from "./CardNfe.vue?vue&type=script&lang=js&"
import style0 from "./CardNfe.vue?vue&type=style&index=0&id=28b8a086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8a086",
  null
  
)

export default component.exports